import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0.2, stagger = 0.13 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, delay: delay + i * stagger, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function Marquee({ items, className = "" }) {
  const Row = () => (
    <div className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="px-8 font-mono text-xs uppercase tracking-[0.25em] text-steel-secondary">{item}</span>
          <span className="h-1 w-1 rotate-45 bg-steel-brass/70" />
        </span>
      ))}
    </div>
  );
  return (
    <div className={`marquee-hover overflow-hidden ${className}`} data-testid="trust-marquee">
      <div className="animate-marquee flex w-max">
        <Row />
        <Row />
      </div>
    </div>
  );
}

export function SectionHead({ overline, title, copy, className = "", align = "left" }) {
  return (
    <Reveal className={`${align === "center" ? "text-center mx-auto" : ""} max-w-3xl ${className}`}>
      {overline && (
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-steel-brass mb-6">{overline}</p>
      )}
      <h2 className="text-3xl sm:text-4xl lg:text-5xl font-medium leading-[1.1] text-steel-text">{title}</h2>
      <div className={`hairline-glow mt-7 w-28 ${align === "center" ? "mx-auto" : ""}`} />
      {copy && <p className="mt-6 text-base sm:text-lg leading-relaxed text-steel-secondary">{copy}</p>}
    </Reveal>
  );
}
